export const ScheduleTagType = Object.freeze({
    All: -1,
    Schedule: 2,
    Segment: 3,
});
